var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.title
    ? _c("div", { staticClass: "TcTitle" }, [
        _c("h1", [_vm._v(_vm._s(_vm.title.label))]),
        _vm._v(" "),
        _vm.title.back
          ? _c(
              "span",
              {
                staticClass: "text-xl absolute left-0 pl-5 cursor-pointer",
                on: {
                  click: function($event) {
                    return _vm.$root.setPage(_vm.title.back)
                  }
                }
              },
              [_vm._v("← Volver")]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.title.call_back
          ? _c(
              "span",
              {
                staticClass: "text-xl absolute left-0 pl-5 cursor-pointer",
                domProps: { innerHTML: _vm._s(_vm.title.call_back.label) },
                on: { click: _vm.title.call_back.action }
              },
              [_vm._v("...")]
            )
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }